<mat-card style="min-height: 500px">
    <mat-card-content>
        <div class="max-width">
            <div class="d-flex justify-content-start gap-2 mb-4">
                <button class="action-btn action-btn-create" role="button" *ngIf="auth.permissions['SCHOOL_PROGRAM_PAYMENT_ACCUMULATION_SETUP_VIEW']">
                    <i-feather name="plus" class="feather-base"></i-feather>
                    {{ 'PAYMENT_ACCUMULATION_SETUP' | translate }}
                </button>
            </div>
            <div class="form-group row mb-3">
                <div class="col-md-3">
                    <app-select-academic-year-only
                        (academicYearChanged)="onChangeAcademicYear($event); clearData()">
                    </app-select-academic-year-only>
                </div>
                <div class="col-md-3">
                    <app-select-school-level-relation-v2
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        (schoolLevelRelationChanged)="onChangeSchoolLevel($event); clearData()"
                        [isDisabled]="!this.paramForm.get('academic_year')?.value">
                    </app-select-school-level-relation-v2>
                </div>
                <div class="col-md-3">
                    <app-select-school-program
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        [school_location_id]="this.paramForm.get('school_location_id')?.value"
                        [isDisabled]="!this.paramForm.get('school_location_id')?.value"
                        (schoolProgramChanged)="onChangeSchoolProgram($event); clearData()">
                    </app-select-school-program>
                </div>
                <div class="col-md-3">
                    <app-select-school-program-category
                        [school_program_id]="this.paramForm.get('school_program_id')?.value"
                        [isDisabled]="!this.paramForm.get('school_program_id')?.value"
                        [all]="true"
                        (schoolProgramCategoryChanged)="onChangeSchoolProgramCategory($event); clearData()">
                    </app-select-school-program-category>
                </div>
                <div class="col-md-3">
                    <app-select-school-activity
                        (schoolActivityChanged)="onChangeSchoolProgramActivity($event)"
                        [academic_year]="this.paramForm.get('academic_year')?.value"
                        [school_program_id]="this.paramForm.get('school_program_id')?.value"
                        [school_program_category_id]="this.paramForm.get('school_program_category_id')?.value"
                        [has_payment]="true"
                        [isDisabled]="!paramForm.get('school_program_category_id')?.value">
                    </app-select-school-activity>
                </div>
            </div>
            <div class="form-group row mb-3" *ngIf="paramForm.get('school_program_activity_id')?.value">
                <div class="col-md-4">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Search</mat-label>
                        <input matInput [(ngModel)]="searchText" (ngModelChange)="onSearchChange()" placeholder="Search student name...">
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>Paid</mat-label>
                        <mat-select [(ngModel)]="filterPaid" (ngModelChange)="onFilterChange()">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-2">
                    <mat-form-field appearance="outline" class="w-100">
                        <mat-label>VA Generated</mat-label>
                        <mat-select [(ngModel)]="filterVaGenerated" (ngModelChange)="onFilterChange()">
                            <mat-option [value]="null">All</mat-option>
                            <mat-option [value]="true">Yes</mat-option>
                            <mat-option [value]="false">No</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
            </div>
            <div *ngIf="paramForm.get('school_program_activity_id')?.value">
                <table mat-table *ngIf="dataPayment.length > 0 && !loading"
                       [dataSource]="dataPayment" multiTemplateDataRows
                       >

                    <ng-container matColumnDef="checkbox">
                        <th mat-header-cell *matHeaderCellDef style="text-align: center">
                            <mat-checkbox (change)="checkAllCheckboxes($event)"></mat-checkbox>
                        </th>
                        <td mat-cell *matCellDef="let element" class="example-element-weight">
                            <mat-checkbox class="example-margin"
                                [formControl]="checkboxForm.controls[element.registration_payment_id]">
                            </mat-checkbox>
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="student_name">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'STUDENT_NAME' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.student_name || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="va_number">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'VA_NUMBER' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.va_number || '-'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="total_fee">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'TOTAL_FEE' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.total_fee | currency:'IDR':'Rp'}}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="is_paid">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'IS_PAID' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.is_paid ? 'Yes' : '-' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="payment_generated">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'PAYMENT_GENERATED' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            {{element.payment_generated ? 'Yes' : 'No' }}
                        </td>
                    </ng-container>

                    <ng-container matColumnDef="action">
                        <th mat-header-cell *matHeaderCellDef class="cursor-pointer"> {{ 'ACTION' | translate }} </th>
                        <td mat-cell *matCellDef="let element" class="example-element-position">
                            <!-- <i class="fa fa-file-invoice-dollar fs-4" (click)="openPaymentSectionVa(element)"></i> -->
                        </td>
                    </ng-container>

                    <tr mat-header-row *matHeaderRowDef="columnsToDisplay"></tr>
                    <tr mat-row *matRowDef="let element; let i = index; columns: columnsToDisplay;" class="example-element-row">
                    </tr>
                </table>
            </div>
            <mat-paginator
                *ngIf="totalItems > 0"
                [length]="totalItems"
                [pageSize]="pageSize"
                [pageIndex]="page - 1"
                [pageSizeOptions]="[10, 25, 50, 100]"
                (page)="onPageChanged($event)"
                showFirstLastButtons>
            </mat-paginator>
            <div style="display: flex; justify-content: flex-end;">
                <button *ngIf="auth.permissions['SCHOOL_PROGRAM_GENERATE_VA'] && dataPayment.length !== 0" class="btn btn-success mt-4 mb-4" type="button" (click)="generateButton()" [disabled]="getSelectedCheckboxes().length === 0">Generate VA</button>
                <button *ngIf="auth.permissions['SCHOOL_PROGRAM_GENERATE_VA_IPEKA'] && dataPayment.length !== 0" class="btn btn-success mt-4 mb-4 ms-2" type="button" (click)="generateButtonIpeka()" [disabled]="getSelectedCheckboxes().length === 0">Generate VA (IPEKA)</button>
            </div>
        </div>
    </mat-card-content>
</mat-card>
